<template>
  <div class="traMaterialBox">
    <div class="content">
      <div style="display: flex;width: 100%;justify-content: space-between;">
        <el-button type="primary" @click="handAdd()" size="small">新建</el-button>
        <Input
          search
          enter-button
          placeholder=" 请输入名称"
          v-model="fileNameOrTag"
          @on-search="getData(1)"
          style="width: 300px"
        />
      </div>
      <div style="margin-top: 20px;">
        <template>
          <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: 'rgb(250,250,250)' }">
            <el-table-column type="index" :index="serialNumber" label="序号" />
            <el-table-column prop="materialName" label="资料标题"></el-table-column>
            <el-table-column prop="proFileName" label="文件名">
              <template slot-scope="scope">
                <el-link type="primary" @click="downLoad(scope.row)">{{scope.row.proFileName}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="materialType" label="文件类型">
              <template slot-scope="{ row }">
                <span v-if="row.materialType">{{ fileTypeList[row.materialType - 1].name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="tagArr" label="所属类别"></el-table-column>
            <el-table-column prop="uploadingTime" label="上传时间">
              <template slot-scope="{ row }">
                {{ row.uploadingTime | timeFilter }}
              </template>
            </el-table-column>
            <el-table-column prop="uploadingEmpName" label="上传人"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-link type="primary" size="error" @click.native.prevent="editData(scope.row)">编辑</el-link>
                <span style="margin: 0 5px; color: #e8e8e8">|</span>
                <el-link type="danger" size="error" @click.native.prevent="deleteData(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 10px">
            <Page :total="total" :page-size="pageSize" :current="currentPage" @on-change="getData" />
          </div>
        </template>
      </div>
    </div>

    <el-dialog title="新建" :visible.sync="dialogVisible" width="35%" @close="handleClose" top="8vh">
      <!-- <el-row class="my_row">
        <el-col :span="6" class="input_label">上传文件：</el-col>
        <el-col :span="14">
          <el-upload
            ref="uploadFile"
            class="upload-demo"
            drag
            action="/v1/trainMaterials/uploadFile"
            :on-change="handleChange"
            :file-list="fileList"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
          </el-upload>
        </el-col>
      </el-row>
      <el-row class="my_row" style="margin-top: 2%">
        <el-col :span="6" class="input_label">文件标签：</el-col>
        <el-col :span="14" style="width: auto;">
          <el-select
            v-model="value"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择标签"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row> -->
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" size="small" style="width: 100%" label-width="110px">
        <el-form-item label="资料标题" prop="materialName">
          <el-input v-model="ruleForm.materialName" placeholder="标题" />
        </el-form-item>
        <el-form-item label="所属类别" prop="materialCategory">
          <el-input v-model="ruleForm.materialCategory" placeholder="所属类别" />
        </el-form-item>
        <el-form-item label="资料附件" prop="fileList1" class="upload1">
          <el-upload
            ref="uploadFile"
            class="upload-demo"
            drag
            action="/v1/trainMaterials/uploadFile"
            :on-change="handleChange"
            :on-exceed="exceed1"
            :on-remove="remove1"
            :limit="1"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="关键字" prop="tagWord">
          <el-select
            v-model="value"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择标签"
            style="width: 100%"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传人" prop="uploadingEmpId">
          <el-select v-model="ruleForm.uploadingEmpId" style="width: 100%" @change="userChange">
            <el-option v-for="people in userList" :key="people.id" :value="people.id" :label="people.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="上传日期" prop="uploadingTime">
          <el-date-picker
            v-model="ruleForm.uploadingTime"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="文件类型" prop="materialType">
          <el-select v-model="ruleForm.materialType" style="width: 100%">
            <el-option v-for="type in fileTypeList" :key="type.id" :value="type.id" :label="type.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="教程介绍" prop="synopsis">
          <el-input type="textarea" :rows="3" v-model="ruleForm.synopsis" placeholder="教程简介" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="add()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { downLoadDocument } from "@/api/downLoad";
import {  getEmpBindUser, trainMaterialsAdd, trainMaterialsEdit } from '@/api/processManager'
export default {
  data() {
    var checkFile = (rule, value, callback) => {
      if(this.fileList.length === 0) {
        callback(new Error('请上传资料'))
      } else {
        callback()
      }
    }
    var checkTagWord = (rule, value, callback) => {
      if(this.value.length === 0) {
        callback(new Error('请输入关键字'))
      } else {
        callback()
      }
    }
    return {
      tableData: [],
      fileNameOrTag: "",
      pageSize: 10,
      currentPage: 1,
      dialogVisible: false,
      // fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}],
      fileList: [],
      form: {},
      total: 0,
      pageTotal: 0,
      options: [],
      value: [],
      isAdd: true,
      ruleForm: {
        materialName: '',
        materialCategory: '',
        uploadingEmpId: '',
        uploadingTime: '',
        materialType: '',
        synopsis: '',
        proType: 1
      },
      rules: {
        materialName: [{ required: true, message: '请输入' }],
        materialCategory: [{ required: true, message: '请输入' }],
        fileList1: [{ required: true, validator: checkFile, trigger: 'blur' }],
        tagWord: [{ required: true, validator: checkTagWord, trigger: 'blur' }],
        uploadingEmpId: [{ required: true, message: '请选择上传人' }],
        uploadingTime: [{ required: true, message: '请选择上传日期' }],
        materialType: [{ required: true, message: '请选择文件类型' }],
        synopsis: [{ required: true, message: '请输入教程介绍' }],
      },
      userList: [],
      fileTypeList: [
        { id: 1, name: '文档' },
        { id: 2, name: '视频' },
        { id: 3, name: '语音' },
        { id: 4, name: '其它' }
      ]
    };
  },
  mounted: function() {
    this.getData(1);
    this.getUser()
  },
  methods: {
    // 表格序号
    serialNumber(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    exceed1(file, fileList) {
      this.$message.warning('限制上传一个文件')
    },
    remove1(file, fileList) {
      this.fileList = fileList
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    // 获取绑定了用户的员工
    getUser() {
      getEmpBindUser({}).then(res => {
        this.userList = res.body.data
      })
    },
    // 选择上传人
    userChange(id) {
      for(let i in this.userList) {
        if(id === this.userList[i].id) {
          this.ruleForm.uploadingEmpName = this.userList[i].name
        }
      }
    },
    getData: function(page) {
      this.currentPage = page;
      let param = {};
      this.componentsMoudel.httpRequest
        .getRequestHander(
          "/trainMaterials/list_all?limit=" +
            this.pageSize +
            "&curPage=" +
            page +
            "&fileNameOrTag=" +
            this.fileNameOrTag
        )
        .openLoad()
        .startGet(param)
        .then(res => {
          this.tableData = res.body.data;
          // this.currentPage = res.body.page;
          this.total = res.body.cum;
          // this.pageTotal = res.body.pageTotal;
        });
    },
    // 删除按钮
    deleteData: function(val) {
      this.$confirm(`删除 《${val.proFileName}》, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.componentsMoudel.httpRequest
            .getRequestHander("/legislation/delete/" + val.id)
            .openLoad()
            .startPost()
            .then(res => {
              if (this.tableData.length <= 1 && this.currentPage > 1) {
                this.currentPage -= 1;
              }
              this.getData(this.currentPage);
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
            });
        })
        .catch(() => {
          return;
        });
    },
    // 编辑按钮
    editData(row) {
      this.ruleForm = { ...row }
      this.fileList.push(
        { name: row.proFileName, response: { data: row.proUrl } }
      )
      this.value = row.tagArr.split(',')
      this.isAdd = false
      this.dialogVisible = true;
    },
    add() {
      this.$refs['ruleForm'].validate((valid) => {
        if(valid) {
          this.ruleForm.tagArr = this.value.join(",");
          this.ruleForm.proFileName = this.fileList[0].name
          this.ruleForm.proUrl = this.fileList[0].response.data
          if(!this.ruleForm.proUrl) {
            this.ruleForm.proUrl = 'src'
          }
          // 新增
          if(this.isAdd) {
            trainMaterialsAdd(this.ruleForm).then(res => {
              this.$message.success('添加成功')
              this.handleClose();
              this.getData(1)
            })
          // 编辑
          } else {
            trainMaterialsEdit(this.ruleForm).then(res => {
              this.$message.success('编辑成功')
              this.handleClose();
              this.getData(1)
            })
          }
        } else {
          return false
        }
      })
    },
    handleClose(done) {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false
      this.fileList = []
      this.fileList2 = []
      this.value = []
      this.isAdd = true
      this.ruleForm = {
        materialName: '',
        materialCategory: '',
        uploadingEmpId: '',
        uploadingTime: '',
        materialType: '',
        synopsis: '',
        proType: 1
      }
    },
    handAdd() {
      this.form = {};
      this.dialogVisible = true;
    },
    // handleSizeChange(val) {
    //     this.pageSize = val;
    // },
    // handleCurrentChange(val) {
    //     this.currentPage = val;
    // },

    // 下载文件
    downLoad(row) {
      downLoadDocument(row.proUrl, row.proFileName);
    }
  },
  created() {}
};
</script>

<style scoped>
.head {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}

.content {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e9eef3;
}
.traMaterialBox .upload1 /deep/ .el-upload {
  width: 100%
}
.traMaterialBox .upload1 /deep/ .el-upload-dragger {
  width: 100%
}
.traMaterialBox /deep/ .el-form {
  padding-right: 15px
}
</style>
